// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"az_V8b","infoLabel":"az_W8b"};